import {FilterDescriptor, filterBy} from "@progress/kendo-data-query"
import {Chip} from "@progress/kendo-react-buttons"
import {ComboBoxFilterChangeEvent, ComboBox, ListItemProps} from "@progress/kendo-react-dropdowns"
import {FieldRenderProps} from "@progress/kendo-react-form"
import React from "react"
import {TestStation} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"

const BKComboBox = (fielRenderProps: FieldRenderProps) => {
    const {
        allowCustom,
        name,
        label,
        filterable,
        textField,
        dataItemKey,
        loading,
        data,
        stateValue,
        onChange,
        required,
    } = fielRenderProps
    const [filter, setFilter] = React.useState<FilterDescriptor>()

    const bookingDealerID = useAppSelector((state: RootState) => state.containers.motBooking.bookingDetail.dealerID)

    const testStationItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const item = itemProps.dataItem as TestStation
        const itemChildren = (
            <div className="d-flex w-100">
                <div className="me-auto">{li.props.children}</div>
                {item.dealerID === bookingDealerID && (
                    <Chip themeColor={item.dealerDefault ? "info" : "base"} size={"small"}>
                        <span className="small">ATF</span>
                    </Chip>
                )}
            </div>
        )
        return React.cloneElement(li, li.props, itemChildren)
    }

    // const valueRender = (rendering: React.ReactElement<HTMLSpanElement, string | React.JSXElementConstructor<any>>) => {
    //     let input = rendering.props as HTMLInputElement

    //     return (
    //         <div className="d-flex w-100">
    //             <div className="me-auto">{input.value ?? ""}</div>
    //         </div>
    //     )
    // }

    const onFilterChange = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            setFilter(event.filter)
        }
    }

    const validationMessage = name === "testStationID" && required ? "Test station is required" : ""

    return (
        <>
            <ComboBox
                required={required}
                allowCustom={allowCustom}
                name={name}
                value={
                    stateValue !== null || stateValue ? data.find((t: any) => t[`${dataItemKey}`] === stateValue) : null
                }
                textField={textField}
                dataItemKey={dataItemKey}
                data={filterable && filter ? filterBy(data, filter) : data}
                label={label}
                filterable={filterable}
                loading={loading}
                onFilterChange={onFilterChange}
                onChange={onChange}
                validationMessage={validationMessage}
                itemRender={name === "testStationID" ? testStationItemRender : undefined}
                // valueRender={name === "testStationID" ? valueRender : undefined}
            />
        </>
    )
}

export default BKComboBox
